module.exports = __webpack_public_path__ + "img/button-decouvrir.bb6b42c5.png";